module.exports = __webpack_public_path__ + "media/src/images/icon__sad--5-e2e10b312043f98008ce6762ce5a9dbd.png";